<template>
  <b-container class="h-100">
    <b-row class="justify-content-center h-100 text-center">
      <b-col align-self="center" cols="12">
        <img src="@/assets/icon-payment/icon-payment-decline.png" alt="" />
        <h1 class="text-topic">Sorry,</h1>
        <h3 class="font-weight-bold">Your payment was declined.</h3>
        <p class="p-0 m-0">Please try again or use a different payment method.</p>
        <b-button class="mt-5 button__go-to-your-cart" variant="success" @click="gotoCart"
          >Go to your cart</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  methods: {
    gotoCart() {
      this.$router.push({
        name: 'cart-item'
      });
    }
  }
};
</script>

<style lang="css" scoped>
.text-topic {
  color: #ff764d;
  font-weight: 700;
  margin: 35px 0;
}
</style>
